/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const CALCULATE_INTEREST_TAB_DATA = 'CALCULATE_INTEREST_TAB_DATA';
export const GET_COMMON_DROPDOWN_DATA_CI = 'GET_COMMON_DROPDOWN_DATA_CI';
export const GET_QUARTER_DATA = 'GET_QUARTER_DATA';
export const GET_MANUFACTURER_GRID_LIST = 'GET_MANUFACTURER_GRID_LIST';
export const GET_CHECK_DETAILS = 'GET_CHECK_DETAILS';
export const SELECTED_REBATE_PROGRAM = 'SELECTED_REBATE_PROGRAM';
export const GET_CALCULATE_INTEREST_FOR_NDC_MFG =
  'GET_CALCULATE_INTEREST_FOR_NDC_MFG';
export const GET_VALIDATION_CALCULATE_INTEREST =
  'GET_VALIDATION_CALCULATE_INTEREST';
export const HANDLE_ERROR_MESSAGE_FOR_CAL_INT =
  'HANDLE_ERROR_MESSAGE_FOR_CAL_INT';
export const HANDLE_SUCCESS_MESSAGE_FOR_CAL_INT =
  'HANDLE_SUCCESS_MESSAGE_FOR_CAL_INT';
export const NETWORK_ERROR_CALC_INT = 'NETWORK_ERROR_CALC_INT';
export const DETAIL_DATA_CAL_INT = 'DETAIL_DATA_CAL_INT';
